module.exports = __webpack_public_path__ + "static/media/description.c65f90de.jpeg";